<template>
  <div
    style="overflow-y: scroll; height: 430px; padding: 0 8px"
    element-loading-background="#F7F8FC"
    v-loading="loading"
  >
    <el-card>
      <el-table id="optin-table" striped="false" :data="optins">
        <el-table-column width="150px" label="Channels" prop="channel">
          <template slot-scope="scope">
            <div style="cursor: pointer" @click="showChannelOptin(scope.row)">
              {{ scope.row.channel }}
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="Opt-in" prop="optin">
          <template slot-scope="scope">
            <i class="fa fa-check" v-if="scope.row.opt_in" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="Opt-out" prop="optout">
          <template slot-scope="scope">
            <i class="fa fa-check" v-if="scope.row.opt_out" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="Permission" prop="permission">
          <template slot-scope="scope">
            <i class="fa fa-check" v-if="scope.row.permission" />
          </template>
        </el-table-column>
      </el-table>
      <div v-if="getDateOptedIn()" style="margin-top: 10px">
        <label>Date Opted In:</label>
        <span>{{ getDateOptedIn() }}</span>
      </div>
    </el-card>
    <channel-optin-dialog
      :channel="channelData"
      :visible="showChannelOptinCard"
      @close="handleCloseCard"
      v-if="channelData"
    />
  </div>
</template>

<script>
import moment from 'moment';
import ChannelOptinDialog from '@/components/profiles/profile/dialogs/ChannelOptinDialog';

export default {
  name: 'OptinTab',
  components: {
    ChannelOptinDialog,
  },
  data: () => ({
    showChannelOptinCard: false,
    channelData: null,
  }),
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    optins: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getDateOptedIn() {
      if (this.optins.length > 0) {
        const datesOptedIn = this.optins
          .filter(optin => optin.date_opted_in !== null)
          .map(optin => new Date(optin.date_opted_in));

        if (datesOptedIn.length > 0) {
          const dateOptedIn = new Date(Math.min(...datesOptedIn));
          return moment(dateOptedIn).format('dddd, MMMM D, YYYY');
        }
      }
      return null;
    },
    showChannelOptin(channelData) {
      if (channelData) {
        const channelSelected = this.optins.find(optin => optin.channel === channelData.channel);
        if (channelSelected) {
          this.channelData = channelSelected;
          this.showChannelOptinCard = true;
        }
      }
    },
    handleCloseCard() {
      this.showChannelOptinCard = false;
      this.channelData = null;
    },
  },
};
</script>

<style scoped>
#optin-table::before {
  left: 0;
  bottom: 0;
  width: 100%;
  height: 0px;
}
</style>



// WEBPACK FOOTER //
// OptinsTab.vue?4c172656